import { render, staticRenderFns } from "./SigninView.vue?vue&type=template&id=8b50fc88&scoped=true&"
import script from "./SigninView.vue?vue&type=script&lang=js&"
export * from "./SigninView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b50fc88",
  null
  
)

export default component.exports